import React from "react";
import { useDispatch } from "react-redux";
import {
  fabricZoom,
  fabricRotate,
  fabricMoveX,
  fabricMoveY,
} from "../../redux/creators/playerCreators";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlus,
  faMinus,
  faLongArrowLeft,
  faLongArrowRight,
  faLongArrowDown,
  faLongArrowUp,
  faRotateRight,
  faRotateLeft,
} from "@fortawesome/free-solid-svg-icons";
import styled from "styled-components";
import FabricControlsColorToggle from "./FabricControlsColorToggle";
import FabricControlsCustomizeButton from "./FabricControlsCustomizeButton";
import { size, device } from "../../../../utils/breakPoints";

export default function FabricControls() {
  const dispatch = useDispatch();

  return (
    <Container>
      <EditMessage>Image Editing Options</EditMessage>
      <ButtonContainer>
        <Button
          className="threekit-control"
          id="threekit-zoomIn"
          onClick={() => dispatch(fabricZoom(1))}
        >
          <FontAwesomeIcon icon={faPlus} />
        </Button>
        <Button
          className="threekit-control"
          id="threekit-zoomOut"
          onClick={() => dispatch(fabricZoom(-1))}
        >
          <FontAwesomeIcon icon={faMinus} />
        </Button>
        <Button
          className="threekit-control"
          id="threekit-rotate"
          onClick={() => dispatch(fabricRotate(-1))}
        >
          <FontAwesomeIcon icon={faRotateLeft} />
        </Button>
        <Button
          className="threekit-control"
          id="threekit-rotate"
          onClick={() => dispatch(fabricRotate(1))}
        >
          <FontAwesomeIcon icon={faRotateRight} />
        </Button>
        <Button
          className="threekit-control"
          id="threekit-left"
          onClick={() => dispatch(fabricMoveX(-1))}
        >
          <FontAwesomeIcon icon={faLongArrowLeft} />
        </Button>
        <Button
          className="threekit-control"
          id="threekit-right"
          onClick={() => dispatch(fabricMoveX(1))}
        >
          <FontAwesomeIcon icon={faLongArrowRight} />
        </Button>
        <Button
          className="threekit-control"
          id="threekit-down"
          onClick={() => dispatch(fabricMoveY(1))}
        >
          <FontAwesomeIcon icon={faLongArrowDown} />
        </Button>
        <Button
          className="threekit-control"
          id="threekit-up"
          onClick={() => dispatch(fabricMoveY(-1))}
        >
          <FontAwesomeIcon icon={faLongArrowUp} />
        </Button>
      </ButtonContainer>
      <OptionContainer className="threekit-options-section">
        <FabricControlsColorToggle />
        <FabricControlsCustomizeButton />
      </OptionContainer>
    </Container>
  );
}

const Container = styled.div`
  width: 100%;
  margin-top: 10px;
  padding: 10px;
  border-radius: 0.25rem;
  border: 1px solid black;
`;
const EditMessage = styled.div`
  text-align: center;
  font-weight: bold;
`;
const OptionContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  @media ${device.mobileLg} {
    flex-wrap: wrap;
  }
`;
const Button = styled.button`
  width: 38px;
  height: 38px;
  border: none;
  border-radius: 18px;
  background: #ffffff;
`;
const ButtonContainer = styled.div`
  padding-top: 10px;
  padding-bottom: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  @media (min-width: ${size.mobileLg}) {
    > *:nth-child(2n) {
      margin-right: 36px;
    }
    > *:last-child {
      margin-right: 0;
    }
  }
`;
